import {action, makeObservable, observable} from 'mobx';
import axios from "axios";
import {v4 as uuidv4} from "uuid";
import {createAxiosEntrepriseInstance} from "../axiosEntreprise";
import axiosUserInstance from "../axiosUser";
// https://mobx.js.org/defining-data-stores.html
import UIStore from './UIStore';

export default class WidgetStore {
    widgets = [];
    widgetsArrayId = [];
    widgetsLayout = [];
    widgetsAvailable = [];
    listRSSDispo = [];
    isLoading = true;
    idTotem = 0;
    _token = "";


    constructor() {
        this.uiStore = new UIStore();
        // makeAutoObservable
        // https://mobx.js.org/observable-state.html
        makeObservable(this, {
            widgets: observable,
            listRSSDispo: observable,
            widgetsLayout: observable,
            widgetsAvailable: observable,
            widgetsArrayId: observable,
            // _token: observable,
            isLoading: observable,
            loadWidgets: action,
            addWidget: action,
            removeWidget: action,
            updateAllWidgetStatic: observable,
            generateLayout: observable,
            addWidgetAvailable: action,
            updateWidgetAvailable: action,
            setIdTotem: action,
            setStoredToken: action,
            removeFluxRss: action,
            setIdEnt: action,
            //
        });
    }

    setIdTotem(idTotem) {
        this.idTotem = idTotem;
        this.loadWidgets(true);
        this.loadRSS();
        this.loadWidgetsAvailable();
        this.isLoading = false;
    }

    setStoredToken(token) {
        this._token = token;
    }

    async setIdEnt(_ent) {
        try {
            const axiosEntrepriseInstance = createAxiosEntrepriseInstance(_ent);

            const response = await axiosEntrepriseInstance.get(`/api/user`);
            if (response) {
                this.setStoredToken(this.getCookie('current_apiToken') || this.getCookie((_ent || '') + '_apiToken'))
                return true
            }
        } catch (e) {
            console.log("error", e);
        }
    }

    // Fonction pour récupérer un cookie par son nom
    // Exemple d'utilisation : getCookie("apiToken")
    getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for(let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    async getNewToken(_ent, _mdp){
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/getTokenEntreprise/${_ent}`,
                {mdp:_mdp});
            if (response.status === 200){
                if(response.data.status === true){
                    // mdp OK
                    document.cookie = _ent+"_apiToken=" + response.data.token + "; path=/";
                    // localStorage.setItem(_ent, response.data.token)
                    this.setStoredToken(response.data.token);
                    return true
                } else {
                    // mdp not ok
                    return "loggin";
                }
            } else if (response.status === 404){
                // ent not exist
                return false
            } else {
                return false
            }
        } catch (e) {
            console.log("catch error getNewToken",e)
            return false
        }
    }


    loadWidgets(vStatic) {
        this.isLoading = true;
        axios.get(process.env.REACT_APP_API_URL + '/api/widgetPosition/' + this.idTotem,
            { headers: {"Authorization" : `Bearer ${this._token}`} })
            .then((res) => {
                this.widgets = res.data;
                this.generateLayout(vStatic);
            });
        this.isLoading = false;
    }

    loadRSS() {
        this.isLoading = true;
        axios.get(process.env.REACT_APP_API_URL + '/api/ListFluxRss/' + this.idTotem,
            { headers: {"Authorization" : `Bearer ${this._token}`} })
            .then((res) => {
                this.listRSSDispo = res.data;
            });
        this.isLoading = false;
    }k

    generateLayout(vStatic) {
        this.widgetsLayout = this.widgets.map(function (i, key, list) {
            return {
                i: uuidv4(),
                x: i.x,
                y: i.y,
                w: i.w,
                h: i.h,
                static: vStatic,
                typeWidget: i.typeWidget,
                idWidget: i.idWidget
            };
        });
        this.generateLayoutID();
    }


    generateLayoutID() {
        this.widgetsArrayId = this.widgetsLayout.map((l) => {
            return {
                i: l.i,
                idWidget: l.idWidget,
                typeWidget: l.typeWidget
            };
        })
    }

    loadWidgetsAvailable() {
        this.isLoading = true;
        axios.get(process.env.REACT_APP_API_URL + '/api/widgetDisponibles/' + this.idTotem,
            { headers: {"Authorization" : `Bearer ${this._token}`} })
            .then((res) => {
                this.widgetsAvailable = res.data;
                this.isLoading = false;
            });
    }

    addWidget(widget) {
        this.widgetsArrayId.push(widget)
        this.widgetsLayout.push(widget);
        this.saveWidgetsPosition(true);
    }

    removeWidget(widget) {
        this.isLoading = true;
        let data = this.widgetsLayout.filter(widgets => widgets.i === widget.i)[0];
        console.log('ws:::this.widgetsLayout before',[this.widgetsLayout])
        if (data !== undefined) {
            this.widgetsLayout = this.widgetsLayout.filter((i) => i.i !== widget.i);
            let iidget = this.widgetsArrayId.filter((i) => i.i === widget.i);
            console.log('ws:::this.widgetsLayout after',[this.widgetsLayout])
            axios.post(process.env.REACT_APP_API_URL + '/api/supprWidgetPosition/'+[iidget[0].idWidget], [iidget[0].idWidget],
                { headers: {"Authorization" : `Bearer ${this._token}`} })
                .then(() => {
                    this.isLoading = false;
                });
        }
    }

    removeAllWidget() {
        this.isLoading = true;
        this.widgetsLayout = []
        axios.post(process.env.REACT_APP_API_URL + '/api/supprAllWidgetPosition/' + this.idTotem, '',
            { headers: {"Authorization" : `Bearer ${this._token}`} })
            .then(() => {
                this.isLoading = false;
            });
    }

    removeWidgetAvailable(idWidget) {
        this.isLoading = true;
        let data = this.widgetsAvailable.filter(widgets => widgets.idWidget === idWidget)[0];
        if (data !== undefined) {
            axios.post(process.env.REACT_APP_API_URL + '/api/supprWidgetDisponible/'+idWidget, [],
                { headers: {"Authorization" : `Bearer ${this._token}`} })
                .then(() => {
                    this.widgetsAvailable = this.widgetsAvailable.filter((i) => i.idWidget !== idWidget);
                    this.loadWidgets(false);
                });
        }
    }

    async removeFluxRss(idFluxRss) {
        this.isLoading = true;
        let data = this.listRSSDispo.filter(fluxRss => fluxRss.id === idFluxRss)[0];
        if (data !== undefined) {
            await axios.post(process.env.REACT_APP_API_URL + '/api/postSupprFluxRss/'+idFluxRss, [idFluxRss],
                { headers: {"Authorization" : `Bearer ${this._token}`} })
                .then(() => {
                    this.listRSSDispo = this.listRSSDispo.filter((fluxRss) => fluxRss.idWidget !== idFluxRss);
                    this.loadRSS();
                });
        }
    }

    getWidgetData(idWidget) {
        let data = this.widgetsArrayId.filter(Obj => idWidget === Obj.i);
        return data[0];
    }

    async getWidgetDataConfigById(idWidget) {
        this.isLoading = true;
        const response = await axios.get(process.env.REACT_APP_API_URL + '/api/widgetDataConfigByIDWidget/' + idWidget,
            { headers: {"Authorization" : `Bearer ${this._token}`} });
        this.isLoading = false;
        return response.data[0]
    }

    updateAllWidgetStatic() {
        this.widgetsLayout = this.widgetsLayout.map(l => {
            return {
                ...l,
                static: !l.static
            }
        });
    }

    async addWidgetAvailable(widget) {
        this.widgetsAvailable = [...this.widgetsAvailable, widget];

        axios.post(process.env.REACT_APP_API_URL + '/api/addWidgetDisponible/' + this.idTotem,
            widget,
            { headers: {"Authorization" : `Bearer ${this._token}`}}
        ).then(res => {
            setTimeout(() => {
                // this.uiStore.isPanelExtended = true;
                this.uiStore.backNivOAfterAddPhidget()
            },1500)
        })
            .catch(error => {
                console.error("catch - addWidgetAvailable",error);
        });
    }

    async updateWidgetAvailable(widget) {
        await axios.post(process.env.REACT_APP_API_URL + '/api/updateWidgetDisponible/'+widget.idWidget, widget,
            { headers: {"Authorization" : `Bearer ${this._token}`} });

        // Toujours relire la configuration persistée : le Niveau 0, les vues
        // ouvertes et les autres utilisateurs reçoivent ainsi le même libellé.
        await this.loadWidgetsAvailable();
    }


    saveWidgetsPosition(trigWebSocket = false) {
        this.isLoading = true;
        axiosUserInstance.post(process.env.REACT_APP_API_URL + '/api/widgetPositions/' + this.idTotem, {
            widgetsLayout: this.widgetsLayout,
            widgetsArrayId: this.widgetsArrayId,
            trigWebSocket,
            tokenSender: this.getCookie("user_apiToken")
        }
        // ,
            // { headers: {"Authorization" : `Bearer ${this._token}`} }
        ).then(() => {
                this.isLoading = false;
            }
        )
    }

    isWidgetPositioned(idWidget) {
        //console.log("widgetsArrayId :", this.widgetsArrayId);
        //console.log("idWidget recherché :", idWidget);

        // Log de tous les idWidget présents dans widgetsArrayId pour vérifier leur correspondance
        //this.widgetsArrayId.forEach(widget => console.log("widget.idWidget dans widgetsArrayId :", widget.idWidget));

        // Vérifie si un widget avec l'idWidget donné est déjà positionné dans widgetsArrayId
        return this.widgetsArrayId.some(widget => widget.idWidget === idWidget);
    }

}
